import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

import { DEAL_STAGE, Lead } from '@tassomutuo-backoffice/types';
import LabelValueItem from './LabelValueItem';
import formatMoney from '../../../utils/formatMoney';

interface IProps {
  lead: Lead;
  onEditPress: () => void;
}
const LeadDetailsLoanInfoBox = ({ lead, onEditPress }: IProps) => {
  const leadProperties = lead.properties;
  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        bgcolor: 'white',
        m: 2,
        p: 2,
        minWidth: '300px',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap-reverse',
            gap: 2,
            borderBottom: (th) => `1px solid ${th.palette.divider}`,
            width: '100%',
            pb: 1,
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
          >
            <Typography
              fontWeight="bold"
              textTransform="uppercase"
              sx={{ color: (th) => th.palette.secondary.dark }}
            >
              VALORI MUTUO
            </Typography>
            {leadProperties.dealstage !== DEAL_STAGE.DROPPED &&
              leadProperties.dealstage !==
                DEAL_STAGE.ATTO_NOTARILE_CONCLUSO && (
                <IconButton onClick={onEditPress} className='no-print'>
                  <EditIcon sx={{ color: (th) => th.palette.secondary.dark }} />
                </IconButton>
              )}
          </Box>
        </Box>

        <Box pt={1}>
          {leadProperties?.loan_amount && (
            <LabelValueItem
              containerSx={{ pt: 2 }}
              label="Importo mutuo"
              value={formatMoney(+leadProperties.loan_amount)}
            />
          )}
          {leadProperties?.property_value && (
            <LabelValueItem
              containerSx={{ pt: 2 }}
              label="Valore immobile"
              value={formatMoney(+leadProperties.property_value)}
            />
          )}
          {leadProperties?.city_property && (
            <LabelValueItem
              containerSx={{ pt: 2 }}
              label="Comune immobile"
              value={leadProperties?.city_property}
            />
          )}
          {leadProperties?.loan_duration && (
            <LabelValueItem
              containerSx={{ pt: 2 }}
              label="Durata mutuo"
              value={leadProperties?.loan_duration}
            />
          )}
          {leadProperties?.interest_rate && (
            <LabelValueItem
              containerSx={{ pt: 2 }}
              label="Tasso"
              value={leadProperties?.interest_rate}
            />
          )}
          {leadProperties?.purpose && (
            <LabelValueItem
              containerSx={{ pt: 2 }}
              label="Finalità"
              value={leadProperties?.purpose}
            />
          )}
          {leadProperties?.research && (
            <LabelValueItem
              containerSx={{ pt: 2 }}
              label="Ricerca"
              value={leadProperties?.research}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default LeadDetailsLoanInfoBox;
